import React from 'react';
import { Box, Heading } from '@chakra-ui/react';

const SectionTitleCard = ({ children, gradient, icon }) => (
  <Box
    display="inline-block"
    px={{ base: 6, md: 10 }}
    py={{ base: 3, md: 5 }}
    mb={10}
    borderRadius="2xl"
    boxShadow="0 8px 32px 0 rgba(31, 38, 135, 0.10)"
    bgGradient={gradient || "linear(to-r, blue.50, blue.100)"}
    color="white"
    textAlign="left"
    position="relative"
    fontSize={{ base: "2xl", md: "3xl" }}
    letterSpacing="tight"
    ml={{ base: 0, md: 8 }}
    // animation={`${slideIn} 0.8s cubic-bezier(0.23, 1, 0.32, 1)`}
    _before={icon ? {
      content: '""',
      position: "absolute",
      left: "-32px",
      top: "50%",
      transform: "translateY(-50%)",
      width: "32px",
      height: "32px",
      background: `url(${icon}) no-repeat center/contain`
    } : {}}
  >
    <Heading
      as="h2"
      fontSize={{ base: "2xl", md: "3xl" }}
      fontWeight="extrabold"
      bgClip="text"
      bgGradient="linear(to-r, blue.400, blue.300)"
      textShadow="0 2px 8px rgba(0,0,0,0.10)"
      textAlign="left"
    >
      {children}
    </Heading>
  </Box>
);

export default SectionTitleCard; 